var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDuckhuntCapPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.065 19.4991H24.4998V344.673H521.065V19.4991Z",
    fill: "#E19400",
    stroke: "#FFA800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.936 260.49C199.82 226.691 210.14 190.076 218.564 175.993C217.121 173.454 215.835 170.989 214.698 168.6C203.732 159.297 202.878 142.896 203.822 135.858C218.744 81.7538 323.869 107.34 272.27 181.275C282.379 175.36 303.861 178.81 313.338 181.275C319.235 165.22 333.346 154.869 347.036 152.757C379.68 187.612 363.885 237.253 353.354 256.265C325.975 268.939 291.224 285.838 225.936 260.49Z",
    fill: "#FFC700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.7 135.696H194.202C194.202 135.696 189.167 157.236 204.999 169.313C161.821 171.606 164.7 135.696 164.7 135.696Z",
    fill: "#FFC700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.936 260.49C199.82 226.691 210.14 190.076 218.564 175.993C217.121 173.454 215.835 170.989 214.698 168.6C203.732 159.297 202.878 142.896 203.822 135.858C218.744 81.7538 323.869 107.34 272.27 181.275C282.379 175.36 303.861 178.81 313.338 181.275C319.235 165.22 333.346 154.869 347.036 152.757C379.68 187.612 363.885 237.253 353.354 256.265C325.975 268.939 291.224 285.838 225.936 260.49Z",
    stroke: "#FFA800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M164.7 135.696H194.202C194.202 135.696 189.167 157.236 204.999 169.313C161.821 171.606 164.7 135.696 164.7 135.696Z",
    stroke: "#FFA800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuckhuntCapPressed);
export default __webpack_public_path__ + "static/media/duckhunt-cap-pressed.6e5e926150076d3c1d2140c396378ccd.svg";
export { ForwardRef as ReactComponent };